import {useEffect} from 'react';

import {signOutViaBroker} from '../../../utils/signOutViaBroker';

import {Center} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';

export const SignOutPage = () => {

    useEffect(() => {
        const signOutAndRedirect = async () => {
            localStorage.setItem('amplify-signin-with-hostedUI', 'false');
            await signOutViaBroker()
        }

        signOutAndRedirect()
    }, []);


    return (
        <Center>
            <PlatformLoader message={'Signing out...Please, wait!'}/>
        </Center>
    );
};
